import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Switch from '../../../../../../components/molecules/Switch'

const BooleanEditor = forwardRef(({ value, onChange, onBlur, disabled }, ref) => {
  return (
    <Switch
      ref={ref}
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
      onBlur={onBlur}
      disabled={disabled}
    />
  )
})

BooleanEditor.displayName = 'BooleanEditor'

BooleanEditor.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default BooleanEditor
